import React from 'react';
import logo from './logo.svg';
import './App.css';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        <p>
          Made by LovreacT
        </p>
        <a
          className="App-link"
          href="https://github.com/mkskumaran/"
          target="_blank"
          rel="noopener noreferrer"
        >
          View Profile
        </a>
      </header>
    </div>
  );
}

export default App;



// WEBPACK FOOTER //
// ./src/Gst_new.js